/*
* 重定向
* */
import config from '@config';

//服务器返回重定向
export function serverRedirect(opts = {}) {
  let redirectUrl = window._assign.redirect_url;

  redirectUrl = URLenCode.call(this,redirectUrl);

  if (redirectUrl && redirectUrl !== '{$redirect_url}') {
    location.href = `${config.path.indexPath}${redirectUrl}`;
    return false;
  }
  return true;
}

//对url字符转义
function URLenCode(str) {
  return str.replace(/%3D/ig, '=').replace(/%25/g, '%').replace(/%2F/ig, '/').replace(/%2B/ig, '+').replace(/%20/g, ' ').replace(/%3F/ig, '?').replace(/%23/g, '#').replace(/%26/g, '&').replace(/amp;amp;/ig, '&');
}


//304状态重定向
export function redirect(opts = {}) {
  location.href = opts.url || '/';
}